import { biMap } from "@insightfulscience/shared-utils/either";
import UPDATE_BILLING_INFO from "./update-subscription-billing-info.graphql";
import INVOICE_QUOTE_REQUEST from "./request-quote.graphql";
import INVOICE_FREE_TRIAL_BIOLOGICS_REQUEST from "./request-free-trial-biologics.graphql";
import { gqlResultToEither } from "../../utils/gql";

const subscriptionService = ({ gqlClient }) => {
	const updateBillingInfo = ({
		subscriptionId: subscriptionID,
		billingCountryID,
		billingTaxId,
		billingName,
		billingEmail,
		billingCompany,
		billingDepartment,
		billingAddress1,
		billingAddress2,
		billingCity,
		billingState,
		billingZipCode,
		billingPhoneNumber,
	}) =>
		gqlClient(UPDATE_BILLING_INFO, {
			subscriptionID,
			billingInfoInput: {
				billingCountryID,
				billingTaxId,
				billingName,
				billingEmail,
				billingCompany,
				billingDepartment,
				billingAddress1,
				billingAddress2,
				billingCity,
				billingState,
				billingZipCode,
				billingPhoneNumber,
			},
		})
			.then(({ updateSubscriptionBillingInfoV2 }) => updateSubscriptionBillingInfoV2)
			.then(gqlResultToEither)
			.then(
				biMap(
					({ errorCode }) => errorCode,
					({ result }) => result,
				),
			);

	const requestQuote = request =>
		gqlClient(INVOICE_QUOTE_REQUEST, { request }).then(result => result.requestQuoteV2);

	const requestFreeTrialBiologics = request =>
		gqlClient(INVOICE_FREE_TRIAL_BIOLOGICS_REQUEST, { request }).then(
			result => result.requestFreeTrialBiologics,
		);

	return { updateBillingInfo, requestQuote, requestFreeTrialBiologics };
};

export default subscriptionService;
